import { NavLink } from "react-router-dom";
import { FaHome, FaEnvelope, FaBook, FaUsers, FaBell } from "react-icons/fa";

const TeacherNavbar = () => {
  const user = JSON.parse(localStorage.getItem("user"));

  const initials = user?.name
    ?.split(" ")
    .map((n) => n[0])
    .join("")
    .toUpperCase();

  return (
    <>
      <nav className="premium-navbar">

        {/* BRAND */}
        <div className="brand-box">
          <div className="logo-box">ॐ</div>
          <div>
            <div className="brand-title">GURUKRUPA EDUCATION</div>
            <div className="brand-sub">Teacher Panel</div>
          </div>
        </div>

        {/* NAV */}
        <div className="nav-center">
          <NavLink to="/teacher-dashboard" className="nav-pill">
            <FaHome /> Dashboard
          </NavLink>

          <NavLink to="/teacher-dashboard/courses" className="nav-pill">
            <FaBook /> Courses
          </NavLink>

          <NavLink to="/teacher-dashboard/students" className="nav-pill">
            <FaUsers /> Students
          </NavLink>

          <NavLink to="/teacher-dashboard/messages" className="nav-pill">
            <FaEnvelope /> Messages
          </NavLink>
        </div>

        {/* RIGHT */}
        <div className="nav-right">
          <div className="bell"><FaBell /></div>

          <div className="user-pill">
            <div className="avatar">{initials}</div>
            <span>{user?.name}</span>
          </div>
        </div>

      </nav>

      <div className="sub-bar">
        Teacher Portal • Manage Students & Courses
      </div>
    </>
  );
};

export default TeacherNavbar;